/* eslint-disable */

export enum UserType {
  ADMIN = 1,
  CUSTOMER = 2,
  DRIVER = 3,
  PARTNER = 4,
  DISPATCHER = 5,
  CORPORATE = 6,
  MERCHANT = 7,
  HUB = 8,
  VEHICLE = 9,
  // DOCUMENT = 10
  VEHICLE_BRAND = 11,
  VEHICLE_MODEL = 12,
  PICKER = 17
}

export enum DriverStatus {
  PENDING = 1,
  DECLINE = 2,
  APPROVE = 3,
  BLOCK = 4,
  AVAILABLE = 6,
  IN_BOOKING = 7,
  AVAILABLE_FOR_SHARE = 8,
  NEAR_AVAILABLE = 9,
  BUSINESS_OFF = 10
}

export const UserTypeString: Record<any, string> = {
  [UserType.ADMIN]: "label-title.admin",
  [UserType.CUSTOMER]: "label-title.customer",
  [UserType.DRIVER]: "label-title.driver",
  [UserType.PARTNER]: "label-title.partner",
  [UserType.DISPATCHER]: "label-title.dispatcher",
  [UserType.CORPORATE]: "label-title.corporate",
  [UserType.HUB]: "label-title.hub"
};

export enum DriverType {
  ADMIN = 1,
  DRIVER = 3,
  PARTNER = 4,
  HUB = 8
}

export enum Permissions {
  VIEW = 0,
  ADD = 1,
  EDIT = 2,
  DELETE = 3,
  EXPORT = 4
}

export enum LoginBy {
  EMAIL = 1,
  PHONE = 2,
  USERNAME = 3,
  OTP = 4,
  PASSWORD = 5,
  GOOGLE = 6,
  APPLE = 7,
  FACEBOOK = 8
}

export enum DistanceUnit {
  KM = 1,
  MILE = 2
}

export enum VehicleTypeTypes {
  NORMAL = 1,
  ELECTRIC = 2,
  OTHER = 3
}

export enum VehicleTypeEnum {
  NORMAL = 1,
  ELECTRIC = 2
}

export const VehicleTypeString: Record<VehicleTypeEnum, string> = {
  [VehicleTypeTypes.NORMAL]: "label-title.normal",
  [VehicleTypeTypes.ELECTRIC]: "label-title.electric-vehicle"
};

export const VehicleType: { key: VehicleTypeEnum; string: string }[] = [];

Object.values(VehicleTypeEnum).forEach((enumValue) => {
  if (typeof enumValue === "number") {
    VehicleType.push({
      key: enumValue as VehicleTypeEnum,
      string: VehicleTypeString[enumValue as VehicleTypeEnum]
    });
  }
});

export enum DeviceTypeEnum {
  ANDROID = "ANDROID",
  IOS = "IOS",
  WEB = "WEB"
}

export const DeviceType: { key: DeviceTypeEnum; string: string }[] = [];

export const DATE_FORMAT = {
  DD_MM_YYYY: "dd MMM yyyy",
  DD_MM_YY: "DD MMM YY",
  MOMENT_DD_MMM_YYYY: "DD MMM YYYY",
  medium: "medium",
  HH_MM_A: "hh:mm a",
  DASHED_DD_MM_YYYY: "DD-MM-YYYY",
  MMM_YYYY: "MMM-yyyy",
  MOMENT_DD_MMM_COMA_YYYY: "DD MMM, YYYY",
  HH_MMA: "hh:mm A"
};

export const DefaultImages = {
  DefaultUserImage: "../../../../assets/images/default-images/default_user.svg",
  DefaultDocumentImage: "../../../../assets/images/default-images/default_doc.svg",
  DefaultPdfImage: "../../../../assets/images/default-images/pdf_img.png",
  PickupMarker: "assets/images/map-pin/pickup-pin.png",
  DefaultProductImages: "assets/images/default-image.jpg",
  DefaultPromoCode: "../../../../assets/images/default-images/default_promocode.svg",
  LocationPinImage: "../../../../assets/images/default-images/map-pin/location_pin.svg"
};

//pdfsize 1 mb
export const PdfSize = 1024 * 1024;

export const NameMaxLength = 50;

export const PerPageList = [15, 30, 60];

export const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

export const fixedNumber: number = 1;

export enum PaymentMode {
  Cash = 1,
  Wallet = 2,
  Stripe = 3,
  Paystack = 4,
  Razorpay = 5,
  Paylater = 6,
  Mercado = 7,
  Payu = 8,
  Pago = 9,
  PagoC2P = 10,
  Zaincash = 11,
  Hyperpay = 12,
  Nestpay = 13,
  Voucher = 14,
  /** Driver taps the customer's card at pickup (Stripe Terminal on their phone). */
  TapToPay = 15
}

export enum PaymentGatewayEnum {
  Stripe = 3,
  Paystack = 4,
  Razorpay = 5,
  Mercado = 7,
  Payu = 8,
  Pago = 9,
  PagoC2P = 10
}

export const PaymentGatewayType = {
  [PaymentGatewayEnum.Stripe]: 3,
  [PaymentGatewayEnum.Paystack]: 4,
  [PaymentGatewayEnum.Razorpay]: 5,
  [PaymentGatewayEnum.Mercado]: 7,
  [PaymentGatewayEnum.Payu]: 8,
  [PaymentGatewayEnum.Pago]: 9,
  [PaymentGatewayEnum.PagoC2P]: 10
};

export const PaymentModeStrings: { [key: number]: string } = {
  [PaymentMode.Cash]: "label-title.cash",
  [PaymentMode.Wallet]: "label-title.wallet",
  [PaymentMode.Stripe]: "label-title.stripe",
  [PaymentMode.Paystack]: "label-title.paystack",
  [PaymentMode.Razorpay]: "label-title.razorpay",
  [PaymentMode.Paylater]: "label-title.paylater",
  [PaymentMode.Mercado]: "label-title.mercado",
  [PaymentMode.Payu]: "label-title.payu",
  [PaymentMode.Pago]: "label-title.pago",
  [PaymentMode.PagoC2P]: "label-title.pago",
  [PaymentMode.Zaincash]: "label-title.zaincash",
  [PaymentMode.Hyperpay]: "label-title.hyperpay",
  [PaymentMode.Nestpay]: "label-title.nestpay"
};

export const PaymentModeListStrings: Array<any> = [
  { key: PaymentMode.Cash, string: "label-title.cash" },
  { key: PaymentMode.Wallet, string: "label-title.wallet" },
  { key: PaymentMode.Stripe, string: "label-title.stripe" },
  { key: PaymentMode.Paystack, string: "label-title.paystack" },
  { key: PaymentMode.Razorpay, string: "label-title.razorpay" },
  { key: PaymentMode.Mercado, string: "label-title.mercado" },
  { key: PaymentMode.Payu, string: "label-title.payu" },
  { key: PaymentMode.Pago, string: "label-title.pago" },
  { key: PaymentMode.PagoC2P, string: "label-title.pago" },
  { key: PaymentMode.Zaincash, string: "label-title.zaincash" },
  { key: PaymentMode.Hyperpay, string: "label-title.hyperpay" },
  { key: PaymentMode.Nestpay, string: "label-title.nestpay" }
];

export const PaymentGatewayString: Record<any, string> = {
  [PaymentGatewayEnum.Stripe]: "label-title.stripe",
  [PaymentGatewayEnum.Paystack]: "label-title.paystack",
  [PaymentGatewayEnum.Razorpay]: "label-title.razorpay",
  [PaymentGatewayEnum.Mercado]: "label-title.mercado",
  [PaymentGatewayEnum.Payu]: "label-title.payu",
  [PaymentGatewayEnum.Pago]: "label-title.pago",
  [PaymentGatewayEnum.PagoC2P]: "label-title.pago"
};

export const PaymentGateway: { key: PaymentGatewayEnum; string: string }[] = [];

Object.values(PaymentGatewayEnum).forEach((enumValue) => {
  if (typeof enumValue === "number") {
    PaymentGateway.push({
      key: enumValue as PaymentGatewayEnum,
      string: PaymentGatewayString[enumValue as PaymentGatewayEnum]
    });
  }
});

export const PaymentGatewayHandleUrlEnumArray = [PaymentGatewayEnum.Paystack, PaymentGatewayEnum.Pago, PaymentGatewayEnum.PagoC2P];

export const PaymentGatewayHandleHtmlEnumArray = [PaymentGatewayEnum.Razorpay, PaymentGatewayEnum.Mercado, PaymentGatewayEnum.Payu];

export const PaymentGatewayCardEnumArray = [PaymentGatewayEnum.Stripe, PaymentGatewayEnum.Paystack];

export const PaymentGatewayEnumArray = Object.values(PaymentGatewayEnum).filter((value) => typeof value === "number");

export enum PaymentPurposeType {
  ADD_WALLET = 1,
  BOOKING_PAYMENT = 2,
  TIP_PAYMENT = 3,
  SPLIT_PAYMENT = 4,
  CANCEL_BOOKING_PAYMENT = 5,
  ADD_CARD = 6
}

export enum PaymentTransactionStatus {
  PENDING = 1,
  INITIATED = 2,
  PAID = 3,
  FAILED = 4,
  CANCELLED = 5,
  PAY_LATER = 6,
  CAPTURE_REQUIRED = 7
}

export enum ExportHistory {
  QUEUE = "QUEUE",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED"
}

export const SocketEvents = {
  EXPORT_HISTORY: "EXPORT_HISTORY",
  UPDATE_CREDIT: "UPDATE_CREDIT",
  UPDATE_CARD: "UPDATE_CARD",
  SIGN_UP: "SIGN_UP",
  DRIVER_LIVE_LOCATION: "DRIVER_LIVE_LOCATION",
  JOIN_CHAT: "JOIN_CHAT",
  CHAT_MESSAGES_FETCH: "CHAT_MESSAGES_FETCH",
  LEAVE_ROOM: "LEAVE_ROOM",
  CHAT_MESSAGE: "CHAT_MESSAGE",
  JOIN_ROOM: "JOIN_ROOM",
  CHAT_LIST: "CHAT_LIST",
  LEAVE_FROM_CHAT: "LEAVE_FROM_CHAT",
  BOOKING_STATUS: "BOOKING_STATUS",
  BOOKINGS_MONITOR: "BOOKINGS_MONITOR"
};

export const MapPinImages = {
  AvailableMapPin: "/assets/images/map_pin/available_pin.svg",
  OfflineMapPin: "/assets/images/map_pin/offline_pin.svg",
  InBookingMapPin: "/assets/images/map_pin/inbooking_pin.svg",
  RideDriverMapPin: "/assets/images/map_pin/driver_pin.svg",
  DriverMapPin: "/assets/images/map_pin/driver_pin.svg",
  RidePickupMapPin: "/assets/images/map_pin/pickup_pin.svg",
  PickupMapPin: "/assets/images/map_pin/pickup_pin.png",
  DestinationMapPin: "/assets/images/map_pin/destination_pin.png",
  RideDestinationMapPin: "/assets/images/map_pin/destination_pin.svg",
  StopMapPin: "/assets/images/map_pin/add_stop_pin.svg",
  RideStopMapPin: "/assets/images/map_pin/stop_pin.svg",
  OnlineDriver: "/assets/images/map_pin/online_driver.png",
  nearestDriver: "/assets/images/map_pin/driver_car.png",
  /** Top-down car used for the Quick Booking nearby-driver markers. */
  nearbyDriverCar: "/assets/images/map_pin/nearby_driver_car.png",
  inBookingDriver: "/assets/images/map_pin/stop_pin.png"
};

export enum OTPSendMode {
  SMS = 1,
  EMAIL = 2,
  SMS_EMAIL = 3
}

export enum MapType {
  GOOGLE = 1,
  MAP_BOX = 2,
  APPLE = 3,
  LEAFLET = 4
}

/**
 * Resource keys a dispatcher role grants against. Must match the server's `DispatcherRoutes` enum —
 * that enum is the authority, this is what the sidebar filter matches on.
 */
export enum SubAdminRoleKeys {
  DRIVER_EARNING = "DRIVER_EARNING",
  RUNNING_BOOKING = "RUNNING_BOOKING",
  COMPLETED_BOOKING = "COMPLETED_BOOKING",
  SCHEDULED_BOOKING = "SCHEDULED_BOOKING",
  CANCELLED_BOOKING = "CANCELLED_BOOKING",
  ADVERTISE = "ADVERTISE",
  MAP = "MAP",
  BOOK_RIDE = "BOOK_RIDE",
  DISPATCHER_PANEL = "DISPATCHER_PANEL",
  VEHICLE_TRACKING = "VEHICLE_TRACKING",
  BLOCK_LIST = "BLOCK_LIST",
  BLOCK_CUSTOMER = "BLOCK_CUSTOMER",
  // Previously borrowed BOOK_RIDE's key, so they could not be permissioned separately.
  QUICK_BOOKING = "QUICK_BOOKING",
  RECURRING_BOOKING = "RECURRING_BOOKING",
  PROFILE = "PROFILE",
  EXCEPTION = "EXCEPTION"
}

export enum BookingHistoryMainType {
  RUNNING = "RUNNING",
  COMPLETED = "COMPLETED",
  SCHEDULED = "SCHEDULED",
  CANCELLED = "CANCELLED"
}

export enum SetCurrencySignUnit { // 1-Left, 2 Right - Setting currency sign
  LEFT = 1,
  RIGHT = 2
}

/**
 * Sent to the booking list endpoints as `pageType`. Mirrors the server's `BookingPageType`.
 *
 * Values 1 and 2 also drive a server-side bookingTags filter; 3 and 4 are inert as filters and exist so
 * the server can tell which of the four booking pages a request came from when checking the
 * dispatcher role.
 */
export enum BookingHistoryPageType {
  RUNNING = 1,
  SCHEDULED = 2,
  COMPLETED = 3,
  CANCELLED = 4
}

export const PaymentTransactionStatusString: Record<any, string> = {
  [PaymentTransactionStatus.PENDING]: "label-title.pending",
  [PaymentTransactionStatus.INITIATED]: "label-title.initiated",
  [PaymentTransactionStatus.PAID]: "label-title.paid",
  [PaymentTransactionStatus.FAILED]: "label-title.failed",
  [PaymentTransactionStatus.CANCELLED]: "label-title.cancelled",
  [PaymentTransactionStatus.PAY_LATER]: "label-title.paylater",
  [PaymentTransactionStatus.CAPTURE_REQUIRED]: "label-title.capture-required"
};

export enum ExportType {
  USER = 1,
  REFERRAL = 2,

  TRANSACTION_CREDIT = 3,
  TRANSACTION_BANK = 4,
  TRANSACTION_PAYMENT = 5,
  TRANSACTION_REWARD_POINT = 6,

  RUNNING = 7,
  COMPLETED = 8,
  CANCELLED = 9,
  SCHEDULED = 10,
  HISTORY = 18,

  EARNING_DRIVER = 11,
  EARNING_PARTNER = 12,

  CHANGE_LOG = 14
}

export enum FilterType {
  USER = "USER",
  MASS_NOTIFICATION = "MASS_NOTIFICATION",
  REFERRAL = "REFERRAL",
  BOOKING_HISTORY = "BOOKING_HISTORY"
}

export enum ExportHistoryStatusEnum {
  QUEUE = "QUEUE",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED"
}

export enum FilterFields {
  COUNTRY = "COUNTRY",
  CITY = "CITY",
  TYPE = "TYPE",
  TAGS = "TAGS",
  DATE = "DATE",
  USER_TYPE = "USER_TYPE",
  DEVICE_TYPE = "DEVICE_TYPE",
  BOOKING_STATUS = "BOOKING_STATUS",
  BOOKING_TAG = "BOOKING_TAG",
  WALLET_DESCRIPTION = "WALLET_DESCRIPTION",
  REDEEM_DESCRIPTION = "REDEEM_DESCRIPTION",
  BANK_TRANSACTION_STATUS = "BANK_TRANSACTION_STATUS",
  PAYMENTGATEWAY = "PAYMENTGATEWAY",
  BRAND = "BRAND",
  BRAND_MODEL = "BRAND_MODEL",
  PRICE_TYPE = "PRICE_TYPE",
  PAYMENT_MODE = "PAYMENT_MODE",
  PAYMENT_STATUS = "PAYMENT_STATUS",
  CREATED_BY = "CREATED_BY",
  COMPLETED_AT = "COMPLETED_AT",
  CUSTOMERS = "CUSTOMERS",
  DRIVER = "DRIVER",
  PARTNER = "PARTNER",
  CORPORATE = "CORPORATE",
  HUB = "HUB",
  VEHICLE = "VEHICLE",
  RATE = "RATE",
  GENDER = "GENDER",
  TOTAL = "TOTAL",
  DISTANCE = "DISTANCE",
  TIME = "TIME",
  WAITING_TIME = "WAITING_TIME",
  TRAFFIC_TIME = "TRAFFIC_TIME",
  LANGUAGE = "LANGUAGE",
  BOOK_FOR_OTHER = "BOOK_FOR_OTHER",
  PROMO_STATUS = "PROMO_STATUS",
  PROMO = "PROMO",
  DATE_CUSTOM = "DATE_CUSTOM",
  ACCESSIBILITY = "ACCESSIBILITY",
  PAUSED = "PAUSED"
}

export enum DatePickerTabs {
  day = 1,
  week = 2,
  month = 3,
  range = 4
}

export const DriverTypeArray: { key: DriverType; string: string }[] = [];

export const MassNotificationEntities: Array<any> = [
  { key: UserType.CUSTOMER, string: "label-title.customer" },
  { key: UserType.DRIVER, string: "label-title.driver" },
  { key: UserType.DISPATCHER, string: "label-title.dispatcher" },
  { key: UserType.CORPORATE, string: "label-title.corporate" },
  { key: UserType.PARTNER, string: "label-title.partner" }
];

/** Mirrors the server's AttachmentsType (constants.ts) — the `messageType` stored on every chat message. */
export enum AttachmentsType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  AUDIO = "AUDIO",
  DOCUMENT = "DOCUMENT",
  TEXT = "TEXT"
}

export enum ChatType {
  BOOKING_CHAT = "BOOKING_CHAT",
  DRIVER_SUPPORT = "DRIVER_SUPPORT",
  CUSTOMER_DRIVER_CHAT = "CUSTOMER_DRIVER_CHAT",
  CUSTOMER_MERCHANT_CHAT = "CUSTOMER_MERCHANT_CHAT",
  DRIVER_MERCHANT_CHAT = "DRIVER_MERCHANT_CHAT"
}

export enum ViewType {
  RIDE_LIST = 1,
  RIDE_DETAILS = 2,
  BOOK_RIDE = 3,
  DRIVER_LIST = 4,
  DRIVER_DETAILS = 5
}

export enum PriceSign {
  ABSOLUTE = 1,
  PERCENTAGE = 2
}

export enum AddressType {
  PICKUP = "pickup-address",
  DESTINATION = "destination-address",
  STOP = "stop-address"
}

export const AddressTypeString: Array<any> = [
  { key: AddressType.PICKUP, string: "pickup-address" },
  { key: AddressType.DESTINATION, string: "label-title.destination-address" },
  { key: AddressType.STOP, string: "label-title.stop-address" }
];

export const DriverTabTypeString: Array<any> = [
  { key: DriverStatus.IN_BOOKING, string: "label-title.in-job" },
  { key: DriverStatus.AVAILABLE, string: "label-title.online" },
  { key: DriverStatus.APPROVE, string: "label-title.offline" }
];

export enum TripTabType {
  ACTIVE = 1,
  ASSIGNED = 2,
  UNASSIGNED = 3
}

export const TripTabTypeString: Array<any> = [
  { key: TripTabType.ACTIVE, string: "label-title.active" },
  { key: TripTabType.ASSIGNED, string: "label-title.assigned" },
  { key: TripTabType.UNASSIGNED, string: "label-title.unassigned" }
];

export enum ChargeType {
  charges = "charges",
  additionalPrices = "additionalPrices",
  accessibilityPrices = "accessibilityPrices"
}

export enum PriceParamEnum {
  bookingFee = "bookingFee",
  distancePrice = "distancePrice",
  timePrice = "timePrice",
  minimumFee = "minimumFee",
  waitingTimePrice = "waitingTimePrice",
  airportWaitingTimePrice = "airportWaitingTimePrice",
  stopWaitingTimePrice = "stopWaitingTimePrice",
  trafficTimePrice = "trafficTimePrice",
  surgePrice = "surgePrice",
  cancellationPrice = "cancellationPrice",
  promoBonus = "promoBonus",
  airportPrice = "airportPrice",
  zoneToZonePrice = "zoneToZonePrice",
  cityToCityPrice = "cityToCityPrice",
  bidPrice = "bidPrice",
  tipPrice = "tipPrice",
  cartPrice = "cartPrice",
  offerBonus = "offerBonus",
  deliveryPrice = "deliveryPrice",
  platformProfit = "platformProfit"
}

export const PriceParamEnumString: Record<any, string> = {
  [PriceParamEnum.bookingFee]: "label-title.booking-fees",
  [PriceParamEnum.distancePrice]: "label-title.distance-price",
  [PriceParamEnum.timePrice]: "label-title.time-price",
  [PriceParamEnum.minimumFee]: "label-title.minimum-fee",
  [PriceParamEnum.waitingTimePrice]: "label-title.waiting-time-price",
  [PriceParamEnum.airportWaitingTimePrice]: "label-title.airport-waiting-time-price",
  [PriceParamEnum.stopWaitingTimePrice]: "label-title.stop-waiting-time-price",
  [PriceParamEnum.trafficTimePrice]: "label-title.traffic-time-price",
  [PriceParamEnum.surgePrice]: "label-title.surge-price",
  [PriceParamEnum.cancellationPrice]: "label-title.cancellation-price",
  [PriceParamEnum.promoBonus]: "label-title.promo-bonus",
  [PriceParamEnum.airportPrice]: "label-title.airport-price",
  [PriceParamEnum.zoneToZonePrice]: "label-title.zone-to-zone-price",
  [PriceParamEnum.cityToCityPrice]: "label-title.city-to-city-price",
  [PriceParamEnum.bidPrice]: "label-title.bid-price",
  [PriceParamEnum.tipPrice]: "label-title.tip-price",
  [PriceParamEnum.cartPrice]: "label-title.cart-price",
  [PriceParamEnum.offerBonus]: "label-title.offer-bonus",
  [PriceParamEnum.deliveryPrice]: "label-title.delivery-price"
};

export const viewEstimateParamEnumString: Record<any, string> = {
  [PriceParamEnum.bookingFee]: "label-title.base-fare",
  [PriceParamEnum.distancePrice]: "label-title.distance-fare",
  [PriceParamEnum.timePrice]: "label-title.time-fare",
  [PriceParamEnum.minimumFee]: "label-title.minimum-fee",
  [PriceParamEnum.waitingTimePrice]: "label-title.waiting-time-price",
  [PriceParamEnum.airportWaitingTimePrice]: "label-title.airport-waiting-time-price",
  [PriceParamEnum.stopWaitingTimePrice]: "label-title.stop-waiting-time-price",
  [PriceParamEnum.trafficTimePrice]: "label-title.traffic-time-price",
  [PriceParamEnum.surgePrice]: "label-title.surge-price",
  [PriceParamEnum.cancellationPrice]: "label-title.cancellation-fee",
  [PriceParamEnum.promoBonus]: "label-title.promo-bonus",
  [PriceParamEnum.airportPrice]: "label-title.airport-price",
  [PriceParamEnum.zoneToZonePrice]: "label-title.zone-to-zone-price",
  [PriceParamEnum.cityToCityPrice]: "label-title.city-to-city-price",
  [PriceParamEnum.bidPrice]: "label-title.bid-price",
  [PriceParamEnum.tipPrice]: "label-title.tip-price",
  [PriceParamEnum.cartPrice]: "label-title.cart-price",
  [PriceParamEnum.offerBonus]: "label-title.offer-bonus",
  [PriceParamEnum.deliveryPrice]: "label-title.delivery-price"
};

export const backendMaxInt = 9007199254740991;

export enum ConditionOperator {
  EQUAL = 1,
  NOT_EQUAL = 2,
  GREATER_THAN = 3,
  LESS_THAN = 4,
  GREATER_THAN_EQUAL = 5,
  LESS_THAN_EQUAL = 6,
  IN = 7,
  NOT_IN = 8
}

export enum GroupChildType {
  CATEGORY = "CATEGORY",
  PRODUCT = "PRODUCT",
  BRAND = "BRAND",
  GROUP = "GROUP"
}

export const HomeScreenViewType = {
  BUSINESS_TYPE_LIST: 1,
  BUSINESS_TYPE_MAIN_CATEGORY_LIST: 2
};

export const DeviceTypeString: Record<DeviceTypeEnum, string> = {
  [DeviceTypeEnum.ANDROID]: "label-title.android",
  [DeviceTypeEnum.IOS]: "label-title.ios",
  [DeviceTypeEnum.WEB]: "label-title.web"
};

export const DriverTypeString: Record<DriverType, string> = {
  [DriverType.ADMIN]: "label-title.admin",
  [DriverType.DRIVER]: "label-title.driver",
  [DriverType.PARTNER]: "label-title.partner",
  [DriverType.HUB]: "label-title.hub"
};

export enum Gender {
  MALE = "MALE",
  FEMALE = "FEMALE"
}

export const RateRange: Array<number> = [1, 2, 3, 4, 5];

export enum FlatePickrMode {
  single = "single",
  range = "range"
}

export enum ExceptionType {
  SCHEDULE_RIDE_NOT_ASSIGNED = "SCHEDULE_RIDE_NOT_ASSIGNED",
  SCHEDULE_RIDE_NOT_ACCEPTED = "SCHEDULE_RIDE_NOT_ACCEPTED",
  RIDE_NOT_ANSWERED = "RIDE_NOT_ANSWERED",
  DRIVER_NOT_ARRIVED = "DRIVER_NOT_ARRIVED",
  RIDE_NOT_STARTED = "RIDE_NOT_STARTED",
  LOCATION_NOT_UPDATED = "LOCATION_NOT_UPDATED"
}

export enum GenderOptions {
  MALE = "MALE",
  FEMALE = "FEMALE"
}

export enum AccessibilityAndCustomPrice {
  ACCESSIBILITY = 1,
  CUSTOM_PRICE = 2
}

export enum TimeFormatEnum {
  TwelveHour = "hh:mm a",
  TwentyFourHour = "HH:mm"
}

export enum VariantType {
  UNIT = "UNIT",
  SIZE = "SIZE"
}

export enum UnitType {
  GRAM = "GRAM",
  KILOGRAM = "KILOGRAM",
  OUNCE = "OUNCE",
  POUND = "POUND",
  TON = "TON",
  MILLILITER = "MILLILITER",
  LITER = "LITER",
  BOTTLE = "BOTTLE",
  CAN = "CAN",
  GALLON = "GALLON",
  PIECE = "PIECE",
  PACK = "PACK",
  SET = "SET",
  PAIR = "PAIR",
  BOX = "BOX",
  BAG = "BAG",
  BUNDLE = "BUNDLE",
  DOZEN = "DOZEN",
  GROSS = "GROSS",
  CARTON = "CARTON",
  CENTIMETER = "CENTIMETER",
  INCH = "INCH",
  FEET = "FEET",
  METER = "METER",
  NUMBER = "NUMBER"
}

export const UnitTypeString: Record<any, string> = {
  [UnitType.GRAM]: "label-title.gram",
  [UnitType.KILOGRAM]: "label-title.kilogram",
  [UnitType.OUNCE]: "label-title.ounce",
  [UnitType.POUND]: "label-title.pound",
  [UnitType.TON]: "label-title.ton",
  [UnitType.MILLILITER]: "label-title.milliliter",
  [UnitType.LITER]: "label-title.liter",
  [UnitType.BOTTLE]: "label-title.bottle",
  [UnitType.CAN]: "label-title.can",
  [UnitType.GALLON]: "label-title.gallon",
  [UnitType.PIECE]: "label-title.piece",
  [UnitType.PACK]: "label-title.pack",
  [UnitType.SET]: "label-title.set",
  [UnitType.PAIR]: "label-title.pair",
  [UnitType.BOX]: "label-title.box",
  [UnitType.BAG]: "label-title.bag",
  [UnitType.BUNDLE]: "label-title.bundle",
  [UnitType.DOZEN]: "label-title.dozen",
  [UnitType.GROSS]: "label-title.gross",
  [UnitType.CARTON]: "label-title.carton",
  [UnitType.CENTIMETER]: "label-title.centimeter",
  [UnitType.INCH]: "label-title.inch",
  [UnitType.FEET]: "label-title.feet",
  [UnitType.METER]: "label-title.meter",
  [UnitType.NUMBER]: "label-title.number"
};

export enum ScheduleTimeSelectionType {
  TIME_PICKER = 1, // User can pick any time using a time picker
  SLOT = 2, // Predefined time slots like 10:00, 10:15
  SLOT_RANGE = 3 // Time slot ranges like 10:00 - 10:15
}
